export default class SmokescreenImgStyle {
    constructor(bannerPlace) {
        this.bannerPlace = bannerPlace;
        this.stylesheetEl = null;
        this.styleData = [];
    }

    updateStylesheet(locator) {

        if (!this.stylesheetEl) {
            return;
        }

        var stylesheet = this.stylesheetEl.sheet;
        if (!stylesheet) {
            return;
        }

        for (var i = stylesheet.cssRules.length - 1; i >= 0; i--) {
            stylesheet.deleteRule(0);
        }

        var str = '', // .b-img-bottomLeft0 {width: 90px; height: 80px; backgroung: url('data:image...') no-repeat;}
            styleData = this.styleData;

        for (i = 0; i < styleData.length; i++) {
            var className = 'b-img-' + this.bannerPlace + i, width = styleData[i].width, height = styleData[i].height;

            str = '.' + locator.transform(className)
                + ' {'
                + 'width: ' + width + 'px; height: ' + height + 'px; '
                + 'background-image: url(\'' + styleData[i].imgSrc + '\');'
                + '} ';
            stylesheet.insertRule(str, i);
        }

        this.styleData = [];
    }

    registerImageStyle(width, height, src) {
        var idx = this.styleData.length;
        this.styleData.push({
            width: width,
            height: height,
            imgSrc: src
        });
        return idx;
    }

    createStyleEl() {
        var styleEl = document.createElement('style');
        this.stylesheetEl = document.head.appendChild(styleEl);
    }
}
